module.exports = __webpack_public_path__ + "media/instagram-multicolor.30129480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram-multicolor.png
// module id = ./src/assets/instagram-multicolor.png
// module chunks = 0